import React, { useState } from 'react';
import {
  TableRow, TableCell, IconButton,
  Menu, MenuItem as MUIMenuItem,
  Dialog, DialogTitle, DialogContent, DialogContentText,
  DialogActions, Button, Collapse, Box, Typography, Table, TableHead, TableBody
} from '@mui/material';
import {
  MoreVert as MoreVertIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon
} from '@mui/icons-material';
import SiteService from './SiteService';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function ReadingRow({ row, mainMeterId, subMeterId, onDeleted }) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuId, setMenuId] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const openMenu = (e, id) => {
    setAnchorEl(e.currentTarget);
    setMenuId(id);
  };
  const closeMenu = () => setAnchorEl(null);
  const openDialog = () => { setDialogOpen(true); closeMenu(); };
  const closeDialog = () => { setDialogOpen(false); setMenuId(null); };

  const handleDelete = () => {
    SiteService.deleteMeterReading(mainMeterId, subMeterId, menuId)
      .then(() => {
        onDeleted(menuId);
        toast.success('Okuma kaydı silindi!');
      })
      .catch(() => toast.error('Silme sırasında hata oluştu'));
    closeDialog();
  };

  const handleEdit = () => {
    closeMenu();
    navigate(`/update-meter-reading/${mainMeterId}/${subMeterId}/${menuId}`);
  };

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(o => !o)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{row.subMeterDto.kod}</TableCell>
        <TableCell>{row.subMeterDto.name}</TableCell>
        <TableCell>{row.readingTime}</TableCell>
        <TableCell>
          {row.readingReason === 'I' ? 'Sanal' : 'Gerçek'}
        </TableCell>
        <TableCell align="right">
          <IconButton onClick={e => openMenu(e, row.id)}>
            <MoreVertIcon />
          </IconButton>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="subtitle2" gutterBottom>
                Endeks Değerleri
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Tip</TableCell>
                    <TableCell>Açıklama</TableCell>
                    <TableCell>Değer</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.meterReadingDetails.map(detail => (
                    <TableRow key={detail.id}>
                      <TableCell>{detail.indexTypeDto.indexType}</TableCell>
                      <TableCell>{detail.indexTypeDto.indexName}</TableCell>
                      <TableCell>{detail.index}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
        <MUIMenuItem onClick={handleEdit}>Düzenle</MUIMenuItem>
        <MUIMenuItem onClick={openDialog}>Sil</MUIMenuItem>
      </Menu>

      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>Silme Onayı</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bu okuma kaydını silmek istediğinizden emin misiniz?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>İptal</Button>
          <Button color="error" variant="contained" onClick={handleDelete}>
            Sil
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
